import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMoment from 'vue-moment'
import moment from 'moment'
import KProgress from 'k-progress';
require('moment/locale/pt-br')
import vueNumeralFilterInstaller from 'vue-numeral-filter'

// eslint-disable-next-line no-unused-vars
import { LMap, LTileLayer, LMarker, LCircleMarker, LGeoJson, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import { InfoControl, ReferenceChart, ChoroplethLayer } from 'vue-choropleth';

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.component('l-geo-json', LGeoJson)
Vue.component('l-popup', LPopup)
Vue.component('l-circle-marker', LCircleMarker)
Vue.component('l-info-control', InfoControl)
Vue.component('l-reference-chart', ReferenceChart)
Vue.component('l-choropleth-layer', ChoroplethLayer)
Vue.component('k-progress', KProgress);

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.mixin({
  methods:{
    prepareNameFilter: function replaceSpecialChars(str)	{
      if (!str) return '';
      str = str.replace(/[áÁàÀâÂäÄãÃåÅæÆ]/g, 'A');
      str = str.replace(/[çÇ]/g, 'C');
      str = str.replace(/[éÉèÈêÊëË]/g, 'E');
      str = str.replace(/[íÍìÌîÎïÏîĩĨĬĭ]/g, 'I');
      str = str.replace(/[óÓòÒôÔöÖœŒ]/g, 'O');
      str = str.replace(/[úÚùÙûÛüÜ]/g, 'U');
      return str;
    },
  }
})

Vue.use(vueNumeralFilterInstaller, { locale: 'pt-br' })

import VueOffline from 'vue-offline'
Vue.use(VueOffline)

import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.use(VueMoment, {
  moment
})

Vue.directive('can', {
  inserted: function(el) {
    if(JSON.parse(sessionStorage.getItem('IdProfissional')))
      el.remove()
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
